import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  billingList: [
    {
      id: 319,
      deviceId: 'something',
      mrNo: 'something',
      date: 'something',
      startTime: 'something',
      endTime: 'something',
      dataPoints: 'something',
      validDataPoints: 'something',
      totalDays: 'something',
      resident_name: 'something',
      firstName: 'John',
      device_name: '213A',
      lastName: 'Doe',
      n_days: '18',
      dob: '1990-02-01',
      faceSheet: 'demo.pdf',
      dateOfAdmission: '2021-02-01',
    },
    {
      id: 1740,
      deviceId: 'something',
      mrNo: 'something',
      date: 'something',
      startTime: 'something',
      endTime: 'something',
      dataPoints: 'something',
      validDataPoints: 'something',
      totalDays: 'something',
      resident_name: 'something',
      firstName: 'John',
      lastName: 'Doe',
      device_name: '213A',
      n_days: '18',
      dob: '1990-02-01',
      faceSheet: 'demo.pdf',
      dateOfAdmission: '2021-02-01',
    },
    {
      id: 1740,
      deviceId: 'something2',
      mrNo: 'something2',
      date: 'something2',
      startTime: 'something2',
      endTime: 'something2',
      dataPoints: 'something2',
      validDataPoints: 'something2',
      totalDays: 'something2',
      resident_name: 'something2',
      firstName: 'something2',
      lastName: 'something2',
    },
  ],
  loading: false,
}

export default factoryReducer(initialState, actions)
